var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 41 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.167 20H30.5v6.667h-3.333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M33.833 11.667V8.333A3.337 3.337 0 0 0 30.5 5H8.833c-2.757 0-5 2.243-5 5v20c0 3.668 2.99 5 5 5h25a3.337 3.337 0 0 0 3.333-3.333V15a3.337 3.337 0 0 0-3.333-3.333m-25-3.334H30.5v3.334H8.833a1.668 1.668 0 0 1 0-3.334m25 23.334H8.853c-.77-.02-1.687-.325-1.687-1.667V14.692A4.9 4.9 0 0 0 8.833 15h25z"
  })));
};
export default SvgWallet;